// Progressive-profiling helpers: pick at most one relevant, not-recently-dismissed profile section.
const KEY = "wua:profile-nudge";
export const SNOOZE_DAYS = 30;

export const SECTION_HINTS = {
  budget: "your budget, so costs and scholarships fit what your family can manage",
  goals: "your career direction and any employers you're interested in",
  preferences: "your study preferences (campus, staying on after graduation)",
  fee_status: "your passport and residence, so we can show home vs international fees",
  basics: "the year you plan to start and what you want to study",
  grades: "your predicted grades",
};

export function readDismissals() {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
}

export function dismiss(surface, section, now = Date.now()) {
  const d = readDismissals();
  d[`${surface}:${section}`] = now;
  try { localStorage.setItem(KEY, JSON.stringify(d)); } catch { /* storage off: prompt just returns next visit */ }
  return d;
}

// completeness = GET /profile/completeness; priorities = section keys relevant to this surface.
export function pickNudge(completeness, priorities, surface, dismissals = {}, now = Date.now()) {
  const sections = new Map((completeness?.sections || []).map((s) => [s.key, s]));
  for (const key of priorities) {
    const s = sections.get(key);
    if (!s || s.complete) continue;
    const at = dismissals[`${surface}:${key}`];
    if (at && now - at < SNOOZE_DAYS * 864e5) continue;
    return { key, title: s.title, hint: SECTION_HINTS[key] || s.title };
  }
  return null;
}
